import { SubAccount } from "./types/subAccount";

export const sampleSubAccounts: SubAccount[] = [
  {
    id: "1",
    username: "sarah_sales",
    email: "sarah@premiumelectronics.com",
    mobile: "+86 138 0013 8002",
    role: "sales",
    permissions: ["manage_products", "manage_orders", "customer_inquiries", "analytics"],
    status: "active",
    lastLogin: "2024-01-15 14:30",
    createdAt: "2023-11-01 09:00",
    createdBy: "Maria Garcia"
  },
  {
    id: "2", 
    username: "david_support",
    email: "david@premiumelectronics.com",
    mobile: "+86 138 0013 8003",
    role: "support",
    permissions: ["customer_inquiries"],
    status: "active",
    lastLogin: "2024-01-15 16:45",
    createdAt: "2023-10-15 11:30",
    createdBy: "Maria Garcia"
  },
  {
    id: "3",
    username: "lisa_finance",
    email: "lisa@premiumelectronics.com", 
    mobile: "+86 138 0013 8004",
    role: "finance",
    permissions: ["payments", "analytics"],
    status: "active",
    lastLogin: "2024-01-14 10:15",
    createdAt: "2023-12-01 14:20",
    createdBy: "Maria Garcia"
  },
  {
    id: "4",
    username: "mike_logistics",
    email: "mike@premiumelectronics.com",
    mobile: "+86 138 0013 8005", 
    role: "logistics",
    permissions: ["manage_orders"],
    status: "suspended",
    lastLogin: "2024-01-10 08:30",
    createdAt: "2023-09-20 16:45",
    createdBy: "Maria Garcia"
  },
  {
    id: "5",
    username: "jenny_admin",
    email: "jenny@premiumelectronics.com",
    mobile: "+86 138 0013 8006",
    role: "admin", 
    permissions: ["manage_products", "manage_orders", "customer_inquiries", "payments", "analytics", "team_management"],
    status: "active",
    lastLogin: "2024-01-15 18:20",
    createdAt: "2023-08-15 12:00",
    createdBy: "Maria Garcia"
  },
  {
    id: "6",
    username: "tom_sales_trainee",
    email: "tom@premiumelectronics.com",
    mobile: "+86 138 0013 8007",
    role: "sales",
    permissions: ["customer_inquiries"],
    status: "pending",
    lastLogin: "Never",
    createdAt: "2024-01-12 15:30",
    createdBy: "Sarah Johnson"
  }
];